(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  /**
   * CollectionGridPositioner
   *
   * Generic positioning system for pads and stacking blocks within collection grids.
   * Responds to dynamic grid column changes and repositions elements accordingly.
   *
   * Pad positions (first pad base, then +spacing):
   * - 4 columns: 10, 26, 42, 58...
   * - 6 columns: 16, 32, 48, 64...
   * - 8 columns: 13, 29, 45, 61...
   *
   * Stacking position = first pad position + offset (e.g., +8 products)
   */
  class CollectionGridPositioner extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('[id^="Collection-"]');
      if (!this.section) return;

      this.grid = this.querySelector('.collection-section__grid');
      if (!this.grid) return;

      this.enableInlineStacking = this.dataset.enableInlineStacking === 'true';
      this.padSpacing = parseInt(this.dataset.padSpacing, 10) || 16;

      this.parsePadPositions();
      this.parseStackingPositions();

      this.stackingTemplate = this.section.querySelector(
        `#CollectionStackingTemplate-${this.section.dataset.sectionId}`
      );

      this.padsCount = parseInt(this.dataset.padsCount, 10) || 0;
      this.padTemplates = [];
      for (let i = 1; i <= this.padsCount; i++) {
        const template = this.section.querySelector(`#CollectionPadTemplate-${this.section.dataset.sectionId}-${i}`);
        if (template) {
          this.padTemplates.push(template);
        }
      }

      this.insertedElements = [];
      this.currentColumns = null;

      this.init();
    }

    parsePadPositions() {
      try {
        this.padPositions = JSON.parse(this.dataset.padPositions || '{}');
      } catch (e) {
        console.error('CollectionGridPositioner: Invalid pad positions JSON', e);
        this.padPositions = {};
      }
    }

    parseStackingPositions() {
      try {
        this.stackingPositions = JSON.parse(this.dataset.stackingPositions || '{}');
      } catch (e) {
        console.error('CollectionGridPositioner: Invalid stacking positions JSON', e);
        this.stackingPositions = {};
      }
    }

    init() {
      const observer = new MutationObserver(() => {
        this.handleColumnsChange();
      });

      observer.observe(this.section, {
        attributes: true,
        attributeFilter: ['style'],
      });

      this.handleColumnsChange();
    }

    getCurrentColumns() {
      const computedStyle = getComputedStyle(this.section);
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (isMobile) {
        const mobileColumns = computedStyle.getPropertyValue('--collection-columns-mobile').trim();
        return parseInt(mobileColumns, 10) || 2;
      }

      const desktopColumns = computedStyle.getPropertyValue('--collection-grid-columns').trim();
      return parseInt(desktopColumns, 10) || 4;
    }

    handleColumnsChange() {
      const columns = this.getCurrentColumns();

      if (columns === this.currentColumns) return;

      this.currentColumns = columns;
      this.repositionElements();
    }

    clearInsertedElements() {
      for (const element of this.insertedElements) {
        if (element && element.parentNode) {
          element.parentNode.removeChild(element);
        }
      }
      this.insertedElements = [];
    }

    getProductWrappers() {
      return Array.from(this.grid.querySelectorAll('[data-product-index]'));
    }

    repositionElements() {
      this.clearInsertedElements();

      const productWrappers = this.getProductWrappers();
      if (productWrappers.length === 0) return;

      const columns = this.currentColumns;
      const columnsKey = String(columns);

      const insertions = [];

      const padPositionsForColumns = this.padPositions[columnsKey] || [];
      for (let i = 0; i < this.padTemplates.length; i++) {
        const padPos = padPositionsForColumns[i];
        if (padPos && padPos <= productWrappers.length) {
          insertions.push({
            position: padPos,
            type: 'pad',
            template: this.padTemplates[i],
          });
        }
      }

      if (this.enableInlineStacking && this.stackingTemplate) {
        const stackingPos = this.stackingPositions[columnsKey];
        if (stackingPos && stackingPos <= productWrappers.length) {
          insertions.push({
            position: stackingPos,
            type: 'stacking',
            template: this.stackingTemplate,
          });
        }
      }

      insertions.sort((a, b) => b.position - a.position);

      for (const insertion of insertions) {
        const targetIndex = insertion.position - 1;
        if (targetIndex < 0 || targetIndex >= productWrappers.length) continue;

        const targetProduct = productWrappers[targetIndex];
        if (!targetProduct) continue;

        const clone = insertion.template.content.cloneNode(true);
        const element = clone.firstElementChild || clone;

        targetProduct.insertAdjacentElement('afterend', element);

        if (element.nodeType === Node.ELEMENT_NODE) {
          this.insertedElements.push(element);
        } else {
          const inserted = targetProduct.nextElementSibling;
          if (inserted) {
            this.insertedElements.push(inserted);
          }
        }
      }
    }
  }

  if (!customElements.get('collection-grid-positioner')) {
    customElements.define('collection-grid-positioner', CollectionGridPositioner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-list-view"] && !Shopify.designMode) return;
  try {
    
  class DynamicListViewComponent extends HTMLElement {
    #mediaItems;
    #currentId = '0';

    connectedCallback() {
      this.#mediaItems = this.querySelectorAll('.dynamic-list-view__media-item');

      this.addEventListener('accordion:change', (event) => {
        const { accordionId } = event.detail;
        this.#activateMedia(accordionId);
      });
    }

    #activateMedia(mediaId) {
      if (mediaId === this.#currentId) return;

      for (const item of this.#mediaItems) {
        const itemId = item.dataset.mediaId;
        if (itemId === mediaId) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      }

      this.#currentId = mediaId;
    }
  }

  if (!customElements.get('dynamic-list-view')) {
    customElements.define('dynamic-list-view', DynamicListViewComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-product-grid"] && !Shopify.designMode) return;
  try {
    
  class DynamicProductGrid extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.panels = null;
      this.currentIndex = null;
      this.totalSlides = null;
      this.prevButton = null;
      this.nextButton = null;
      this.activeTabIndex = 0;
      this.boundHandleTabClick = this.handleTabClick.bind(this);
      this.boundHandlePrevClick = this.handlePrevClick.bind(this);
      this.boundHandleNextClick = this.handleNextClick.bind(this);
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-tab-button]');
      this.panels = this.querySelectorAll('.dynamic-product-grid__panel');
      this.currentIndex = this.querySelector('[data-current-index]');
      this.totalSlides = this.querySelector('[data-total-slides]');
      this.prevButton = this.querySelector('[data-prev-button]');
      this.nextButton = this.querySelector('[data-next-button]');

      this.tabs.forEach((tab) => {
        ['click', 'mouseenter'].forEach((event) => {
          tab.addEventListener(event, this.boundHandleTabClick);
        });
      });

      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.boundHandlePrevClick);
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.boundHandleNextClick);
      }

      this.updatePagination();
      this.setupSliderListeners();
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        ['click', 'mouseenter'].forEach((event) => {
          tab.removeEventListener(event, this.boundHandleTabClick);
        });
      });

      if (this.prevButton) {
        this.prevButton.removeEventListener('click', this.boundHandlePrevClick);
      }
      if (this.nextButton) {
        this.nextButton.removeEventListener('click', this.boundHandleNextClick);
      }
    }

    handleTabClick(event) {
      const target = event.target;
      if (target.tagName === 'A') return;

      const button = event.currentTarget;
      const index = parseInt(button.dataset.index, 10);

      this.tabs.forEach((tab) => {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
      });

      this.panels.forEach((panel) => {
        panel.classList.remove('is-active');
      });

      button.classList.add('is-active');
      button.setAttribute('aria-selected', 'true');

      const panel = this.querySelector(`[data-index="${index}"].dynamic-product-grid__panel`);
      if (panel) {
        panel.classList.add('is-active');
        // Force layout update for Embla
        const slider = panel.querySelector('slider-component');
        if (slider && slider.embla) {
          slider.embla.reInit();
        }
      }

      this.activeTabIndex = index - 1;
      this.updatePagination();
      this.setupSliderListeners();
    }

    getActiveSlider() {
      const activePanel = this.querySelector('.dynamic-product-grid__panel.is-active');
      if (!activePanel) return null;
      return activePanel.querySelector('slider-component');
    }

    setupSliderListeners() {
      const slider = this.getActiveSlider();
      if (!slider) return;

      const checkEmbla = () => {
        if (slider.embla) {
          slider.embla.on('select', () => {
            this.updatePagination();
          });
          slider.embla.on('scroll', () => {
            this.updateButtonStates();
          });
          this.updateButtonStates();
        } else {
          requestAnimationFrame(checkEmbla);
        }
      };
      checkEmbla();
    }

    updatePagination() {
      const activePanel = this.querySelector('.dynamic-product-grid__panel.is-active');
      if (!activePanel) return;

      const slides = activePanel.querySelectorAll('.dynamic-product-grid__slide');
      const slider = activePanel.querySelector('slider-component');

      if (this.totalSlides) {
        this.totalSlides.textContent = slides.length.toString();
      }

      if (slider && slider.embla && this.currentIndex) {
        const currentSlide = slider.embla.selectedScrollSnap() + 1;
        this.currentIndex.textContent = currentSlide.toString();
      } else if (this.currentIndex) {
        this.currentIndex.textContent = '1';
      }

      this.updateButtonStates();
    }

    updateButtonStates() {
      const slider = this.getActiveSlider();
      if (!slider || !slider.embla) {
        if (this.prevButton) this.prevButton.disabled = true;
        if (this.nextButton) this.nextButton.disabled = true;
        return;
      }

      const embla = slider.embla;
      if (this.prevButton) {
        this.prevButton.disabled = typeof embla.canScrollPrev === 'function' ? !embla.canScrollPrev() : true;
      }
      if (this.nextButton) {
        this.nextButton.disabled = typeof embla.canScrollNext === 'function' ? !embla.canScrollNext() : true;
      }
    }

    handlePrevClick() {
      const slider = this.getActiveSlider();
      if (slider && slider.embla && typeof slider.embla.scrollPrev === 'function') {
        slider.embla.scrollPrev();
        this.updatePagination();
      }
    }

    handleNextClick() {
      const slider = this.getActiveSlider();
      if (slider && slider.embla && typeof slider.embla.scrollNext === 'function') {
        slider.embla.scrollNext();
        this.updatePagination();
      }
    }
  }

  if (!customElements.get('dynamic-product-grid')) {
    customElements.define('dynamic-product-grid', DynamicProductGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
